import React, { Component } from 'react';
import { TextField, FormControl, Radio, RadioGroup, FormControlLabel, FormLabel } from '@mui/material';
import { Nav, Button, Popover, OverlayTrigger, ListGroup } from 'react-bootstrap';
import { dailyReportsTypes } from '../../../../services/common/optionsData';
import ReportsBreadcrumb from './dailyReportsBreadcrumb';
import DateRangeFilter from '../../../common/DateRangeFilter';

class ReportsSearchMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { gridViews, activeGridView } = this.props;
        const popoverSaveView = (
            <Popover id="popover-positioned-bottom" title="Popover bottom" className="p-2">
                <h4>Save view</h4>
                <p>You can save filters, page size, and column to this view</p>
                <div className="mb-2">
                    <Button
                        onClick={() => this.props.updateView(activeGridView)}
                        className="mr-2"
                        disabled={gridViews.length === 0 ? true : ''}
                    >
                        Save
                    </Button>
                    <Button onClick={() => this.props.openCreateView(false)}>Save as new</Button>
                    <br />
                </div>
            </Popover>
        );
        const popoverEditView = (
            <Popover id="popover-positioned-bottom" title="Popover bottom">
                <ListGroup>
                    <ListGroup.Item action onClick={() => this.props.renameActiveView()}>
                        Rename
                    </ListGroup.Item>
                    <ListGroup.Item action onClick={() => this.props.deleteActiveView()}>
                        Delete
                    </ListGroup.Item>
                </ListGroup>
            </Popover>
        );
        return (
            <div>
                <ReportsBreadcrumb onBtnExport={this.props.onBtnExport} />
                <div className="row">
                    <div className="grid-buttons absolute-buttons">
                        <div className="text-center">
                            <TextField
                                sx={{ width: '100px' }}
                                label="Page Size"
                                id="page-size"
                                InputLabelProps={{
                                    shrink: true
                                }}
                                type="number"
                                size="small"
                                value={this.props.page_size}
                                onChange={this.props.onPageSizeChanged}
                                margin="none"
                            />
                            <Button onClick={() => this.props.openCreateView(true)} className="btn btn-primary ml-2">
                                + Add view
                            </Button>
                            <OverlayTrigger trigger="focus" placement="bottom" overlay={popoverSaveView}>
                                <Button
                                    className="btn btn-primary ml-2"
                                    disabled={activeGridView.name === 'Default' ? true : ''}
                                >
                                    <i className="far fa-save"></i> Save view
                                </Button>
                            </OverlayTrigger>
                            <Button
                                onClick={() => this.props.openAllGridViews(true)}
                                className="btn btn-primary ml-2"
                                disabled={gridViews.length === 0 ? true : ''}
                            >
                                All views
                            </Button>
                            <button className="btn btn-primary ml-2" onClick={() => this.props.resetState()}>
                                {' '}
                                <i className="fa fa-repeat"></i> Default
                            </button>
                        </div>
                    </div>
                </div>
                {gridViews.length > 0 && (
                    <Nav
                        className="mt-3 mb-2 px-2 table-nav"
                        variant="tabs"
                        activeKey={activeGridView._id}
                        onSelect={(selectedKey) => this.props.handleTabChange(selectedKey)}
                    >
                        {gridViews.map((view) => (
                            <Nav.Item key={view._id}>
                                <Nav.Link eventKey={view._id}>
                                    {view.name}
                                    {activeGridView._id === view._id && view.name !== 'Default' ? (
                                        <OverlayTrigger trigger="focus" placement="bottom" overlay={popoverEditView}>
                                            <Button variant="link" className="p-0 text">
                                                <i className="fa fa-pen pl-2 text-primary"></i>
                                            </Button>
                                        </OverlayTrigger>
                                    ) : (
                                        <div style={{ padding: '3px 0' }}></div>
                                    )}
                                </Nav.Link>
                            </Nav.Item>
                        ))}
                        <Nav.Item key="add_btn">
                            <Button variant="link" onClick={() => this.props.openCreateView(true)}>
                                <i className="fa fa-plus text-primary"></i>{' '}
                            </Button>
                        </Nav.Item>
                    </Nav>
                )}

                <div className="row mt-3" style={{ padding: '12px' }}>
                    <div className="col-md-10">
                        <div className="row">
                            <div className="col-md-6 pl-4">
                                <FormControl component="fieldset">
                                    <FormLabel style={{ marginBottom: '0px' }}>Type</FormLabel>
                                    <RadioGroup
                                        aria-label="result"
                                        name="type"
                                        value={this.props.reportType}
                                        onChange={this.props.handleFiltersChange}
                                        style={{ flexDirection: 'row' }}
                                    >
                                        {dailyReportsTypes.map((res) => {
                                            return (
                                                <FormControlLabel
                                                    key={res.code}
                                                    value={res.code}
                                                    control={<Radio />}
                                                    label={res.value}
                                                />
                                            );
                                        })}
                                    </RadioGroup>
                                </FormControl>
                                <TextField
                                    label="Current Grid Search"
                                    variant="outlined"
                                    className="filter-search-bar mb-3"
                                    id="reset-form"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    type="string"
                                    margin="dense"
                                    onChange={this.props.onFilterTextChange}
                                />
                            </div>
                            <div className="col-md-6">
                                <div className="row" style={{ marginTop: '-15px' }}>
                                    <div className="col-md-12">
                                        <DateRangeFilter
                                            date_range={this.props.date_range}
                                            from_date={this.props.from_date}
                                            to_date={this.props.to_date}
                                            updateDateRange={this.props.updateDateRange}
                                            handleDateFiltersChange={this.props.handleDateFiltersChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 text-right">
                        <span>
                            <button className="btn btn-primary" onClick={() => this.props.clearFilter()}>
                                <i className="fa fa-times" aria-hidden="true"></i> Clear Filters
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReportsSearchMenu;
